module.exports = __webpack_public_path__ + "static/media/IMG_4172.5bbe7e15.JPG";